import { useRef, useEffect, useCallback } from "react";

export const useScrollHandler = () => {
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  const handleWheel = useCallback((e: WheelEvent) => {
    if (scrollContainerRef.current) {
      const container = scrollContainerRef.current;
      const scrollAmount = e.deltaY;
      container.scrollLeft += scrollAmount;
      e.preventDefault();
    }
  }, []);

  useEffect(() => {
    const container = scrollContainerRef.current;
    if (container) {
      container.addEventListener("wheel", handleWheel, { passive: false });
      return () => {
        container.removeEventListener("wheel", handleWheel);
      };
    }
  }, [handleWheel]);

  return {
    scrollContainerRef,
  };
};
